'use strict';
import axios from 'axios';
import constant from '../constant';

foxdrive_api.setServiceHost(constant.apiUrl);
console.log(constant.apiUrl);

axios.defaults.timeout = 300000;  //timeout 5min
axios.defaults.baseURL = constant.apiUrl;
axios.interceptors.request.use(function(config) {
  config.headers['Authorization'] = 'Bearer ' + foxdrive_api.getCookie('access_token');
  return config;
}, function(erro) {
  console.log(error); // for debug
  Promise.reject(error);
});

var base = '';

export const requestLogin = params => { 
  return axios.post(`${base}/account/api/users/login`, params).then(res => res.data); 
};

export const forgetPassword = params => { 
  return axios.post(`${base}/account/api/users/forgetpwd`, params).then(res => res.data); 
};

export const verifyWithToken = params => { 
  return axios.get(`${base}/account/api/users/resetpwd/` + params.token).then(res => res.data); 
};

export const changePwdWithToken = params => { 
  return axios.post(`${base}/account/api/users/resetpwd/` + params.token, params.pwd).then(res => res.data); 
};
/*
export const requestLogout = params => { return axios.get(`${base}/account/logout`, { params: params }); }
*/
export default {
  /****************************************************************************************************  
    *系統相關
  /****************************************************************************************************
  /**
    * getVersion 取得後台版本
    * @return {string}    version                - 版本號
    */   
   getVersion: function() {
    return axios.get('/api/science/version').then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
    * getConfigs 取得系統設定
    * @return {string}    result.key                - 設定項目
  	* @return {number}    result.value              - 設定值
    */   
  getConfigs: function() {
    return axios.get('/api/science/configs').then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
    * putConfig 修改系統設定
    * @param  {string}    key            - 設定項目
  	* @param  {number}    value          - 設定值
    */   	
  putConfig: function(key, value) {
  	return axios.put('/api/science/configs/' + key, {
      value: value
   	}).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /****************************************************************************************************  
    *資源相關
  /****************************************************************************************************  
  /**
    * getResources 取得資源列表
    * @param  {number}    categoryId                - 主題分類Id
    * @param  {number}    actual_depid              - 真實部門Id
    * @param  {number[]}  level                     - 程度，預設不區分(允許值: 1-4)
    * @param  {string[]}  type                      - 檔案類型，預設不區分(允許值: "video", "doc")
    * @param  {number}    secret                    - 機密，預設不區分(允許值: 0, 1)
    * @param  {number}    start                     - 上架時間，起始時間 timestamp
    * @param  {number}    end                       - 上架時間，截止時間 timestamp
    * @param  {number}    size                      - 筆數(預設值: 10)
    * @param  {number}    offset                    - 查詢筆數起點位移(預設值: 0)
    * @param  {string}    keyword                   - 關鍵字
    * @param  {string}    order                     - 上架排序(預設值: desc, 允許值: "desc", "asc") 
    * @param  {string}    by                        - 上架排序依據(預設值: ctime, 允許值: "ctime", "level", "code", "title", "category", "secret") 
    * @param  {number}    enable                    - 資源狀態(允許值: 0:禁用, 1:啟用)
  	* @return {object}    result                    - 結果陣列
  	* @return {number}    result.id                 - 資源Id
  	* @return {string}    result.code               - 資源編碼
  	* @return {string}    result.title              - 資源標題
  	* @return {string}    result.description        - 資源敘述
  	* @return {object}    result.category           - 資源主題分類
  	* @return {number}    result.category.id        - 資源主題分類Id
  	* @return {string}    result.category.code      - 資源主題分類代碼
  	* @return {string}    result.category.title     - 資源主題分類標題
  	* @return {number}    result.level              - 資源級別
  	* @return {number}    result.secret             - 資源機密
  	* @return {number}    result.ctime              - 資源建立時間
  	* @return {string[]}  result.keywords           - 資源關鍵字
  	* @return {object}    result.fileAttrs          - 資源附檔
  	* @return {string}    result.fileAttrs.fileid   - 資源附檔fileid
  	* @return {string}    result.fileAttrs.filename - 資源附檔
  	* @return {string}    result.fileAttrs.type     - 資源附檔檔案類型
  	* @return {number}    total                     - total
  	*/	
  getResources: function({categoryId, actual_depid, level, type, author,
     secret, start, end, size, offset, keyword, tag, order, by, enable}) {
    //parse
    var levelArray = []; 
    if(level > 0 && level < 5) {
      levelArray.push(level);
    } else if(level === 5) {
      levelArray.push(1);
      levelArray.push(2);
    } else if(level === 6) {
      levelArray.push(1);
      levelArray.push(3);
    } else if(level === 7) {
      levelArray.push(1);
      levelArray.push(4);
    } else if(level === 8) {
      levelArray.push(2);
      levelArray.push(3);
    } else if(level === 9) {
      levelArray.push(2);
      levelArray.push(4);
    } else if(level === 10) {
      levelArray.push(3);
      levelArray.push(4);
    } else if(level === 11) {
      levelArray.push(1);
      levelArray.push(2);
      levelArray.push(3);
    } else if(level === 12) {
      levelArray.push(1);
      levelArray.push(2);
      levelArray.push(4);
    } else if(level === 13) {
      levelArray.push(1);
      levelArray.push(3);
      levelArray.push(4);
    } else if(level === 14) {
      levelArray.push(2);
      levelArray.push(3);
      levelArray.push(4);
    } else if(level === 15) {
      levelArray.push(1);
      levelArray.push(2);
      levelArray.push(3);
      levelArray.push(4);
    } 
 
    var typeArray = [];
    if(type === "video" || type === "doc") {
      typeArray.push(type);
    } else if(type === "all") {
      typeArray.push('video');
      typeArray.push('doc'); 
    } 
 
  	return axios.get('/api/science/resources', {
  		params: {
          categoryId: categoryId,
          actual_depid: actual_depid,
        	level: levelArray,
          type: typeArray,
          author: author,
        	secret: secret,
        	start: start,
        	end: end, 
        	size: size,
        	offset: offset,
          keyword: keyword,
          tag: tag,
        	order: order,
          by: by,
          enable: enable,
    	}
    }).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /**
    * getResourceDetail 取得單一資源
    * @param  {number}    resourceId                   - 特定資源的ID
  	* @return {object}    result                       - 結果陣列
  	* @return {number}    result.id                    - 資源Id
  	* @return {string}    result.code                  - 資源編碼
  	* @return {string}    result.title                 - 資源標題
  	* @return {string}    result.description           - 資源敘述
  	* @return {object}    result.category              - 資源主題分類
  	* @return {number}    result.category.id           - 資源主題分類Id
  	* @return {string}    result.category.code         - 資源主題分類代碼
    * @return {string}    result.category.title        - 資源主題分類標題
    * @return {object}    result.dep                   - 部門
    * @return {number}    result.dep.id                - 部門Id
  	* @return {string}    result.dep.title             - 部門標題
  	* @return {number}    result.level                 - 資源級別
  	* @return {number}    result.secret                - 資源機密
  	* @return {number}    result.ctime                 - 資源建立時間
  	* @return {string[]}  result.keywords              - 資源關鍵字
  	* @return {object}    result.fileAttrs             - 資源附檔
  	* @return {string}    result.fileAttrs.fileid      - 資源附檔fileid
  	* @return {string}    result.fileAttrs.filename    - 資源附檔
  	* @return {string}    result.fileAttrs.type        - 資源附檔檔案類型
  	* @return {string}    result.fileAttrs.downloadurl - 資源附件下載連結
	  */	
  getResourceDetail: function(resourceId) {
  	return axios.get('/api/science/resources/' + resourceId, {
     }).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /**
    * downloadResource 下載附件
    * @param {number}  resourceId   - 特定資源的ID
    * @param {string}  fileId      - fileId
    * @return {string} downloadURL - downloadLink
    */    
  downloadResource: function(resourceId, fileId) {
    return axios.get('/api/science/resources/download/' + resourceId + '/' + fileId).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    }); 
  },
  /**
    * getResourceUploadVariable 取得資源上傳參數
    * @return {string}    uploadURL - 上傳使用的API位址
    * @return {string}    folderId  - 上傳使用的資料夾fileId
  	*/   	
  getResourceUploadVariable: function() {
  	return axios.get('/api/science/resources/variable').then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /**
    * deleteResource 刪除單一資源
    * @param {number} resourceId - resourceId
    * @return none
  	*/   	
  deleteResource: function(resourceId) {
  	return axios.delete('/api/science/resources/' + resourceId, {
      resourceId: resourceId,
     }).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /**
    * addResource 新增單一資源
    * @param  {string}    resource.title       - 標題
    * @param  {string}    resource.description - 敘述
    * @param  {number}    resource.categoryId  - 主題分類Id
    * @param  {number}    resource.level       - 級別(允許值: 1-4)
    * @param  {number}    resource.secret      - 機密(允許值: 0, 1)
    * @param  {string[]}  resource.keywords    - keywords
    * @param  {string[]}  resource.fileIds     - 已上傳完成的fileId
    * @param  {string}    resource.author      - 作者
    * @return {number}    resourceId  - 最新建立的資源Id
    */    
  addResource: function(resource) {
    return axios.post('/api/science/resources', {
      title: resource.title,
      description: resource.description,
      categoryId: resource.categoryId,
      level: resource.level,
      secret: resource.secret,
      keywords: resource.keywords,
      fileIds: resource.fileIds,
      author: resource.author
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    }); 
  },
  /**
    * fixResource 修改單一資源
    * @param  {number}    resourceId            - resourceId
  	* @param  {string}    resource.title        - 標題
  	* @param  {string}    resource.description  - 敘述
  	* @param  {number}    resource.categoryId   - 主題分類Id
  	* @param  {number}    resource.level        - 級別(允許值: 1-4)
  	* @param  {number}    resource.secret       - 機密(允許值: 0, 1)
  	* @param  {string[]}  resource.keywords     - keywords
    * @param  {string[]}  resource.fileIds      - 已上傳完成的fileId
    * @param  {string}    resource.author       - 作者
    * @return none
    */   	
   fixResource: function(resourceId, resource) {
  	return axios.put('/api/science/resources/' + resourceId, {
      resourceId: resourceId,
   		title: resource.title,
   		description: resource.description,
   		categoryId: resource.categoryId,
   		level: resource.level,
   		secret: resource.secret,
   		keywords: resource.keywords,
      fileIds: resource.fileIds,
      author: resource.author
   	}).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /**
    * setResourceWatchTime 儲存檔案閱讀紀錄
    * @param {Number}    resourceId - resourceId
    * @param {string}    fileId     - fileId
    * @param {Number}    watchtime  - watchtime
  	*/   	
    setResourceWatchTime: function(resourceId, fileId, watchtime) {
      return axios.post('/api/science/resources/watchtime/' + resourceId + '/' + fileId, {
        watchtime: watchtime
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return error.response;
      });	
    },
  /**
    * resourceEnableP 啟用/禁用單一資源
    * @param  {number}    resourceId            - resourceId
  	* @param  {boolean}    enable                - 啟用/禁用
    * @return none
    */   	
    enableResource: function(resourceId, enable) {
      return axios.put('/api/science/resources/resourceEnable/' + resourceId, {
        resourceId: resourceId,
        enable: enable
       }).then(function(response) {
        return response.data;
      }).catch(function (error) {
        return error.response;
      });	
    },
  /**
  * getPopular 取得熱門主題
  * @param {number[]}  categoryId         - 篩選分類
  * @param {number}    startTime          - 開始時間(timestamp)
  * @param {number}    endTime            - 結束時間(timestamp)
  * @param {string}    cache              - 快取種類(week,history,acc)
  */   
  getPopular: function(categoryId = [], startTime = null, endTime = null, cache = null) {
    let url = '/api/science/resources/popular';
    return axios.get(url, {
      params: {
        categoryId: categoryId,
        startTime: startTime,
        endTime: endTime,
        cache: cache,
      }
    }).then(function(response) {
      return response.data.result;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
    * getCourse 取得必選修列表
    * @param {number}    course_actual_depid  - 部門id
    * @param {number}    course_type          - 必選修種類(0:選修,1.必修)
    * @param {number}    size                 - 筆數(預設值: 10)
    * @param {number}    offset               - 查詢筆數起點位移(預設值: 0)
    * @param {string}    keyword              - 關鍵字
    * @param {string}    by                   - 排序欄位(預設值: mtime, 允許值: "code", "title", "department", "category", "level", "rating", "mtime") 
    * @param {string}    order                - 排序方式(預設值: desc, 允許值: "desc", "asc") 
    */
  getCourse: function({course_actual_depid, course_type, size, offset, keyword, by, order}) {
    return axios.get('/api/science/resources/course', {
  		params: {
        course_actual_depid: course_actual_depid,
        course_type: course_type,
        size: size,
        offset: offset,
        keyword: keyword,
        by: by,
        order: order,
    	}
    }).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});	
  },
  /**
    * addCourse 新增必選修
    * @param {number}    resource_id          - 資源id
    * @param {number}    actual_depid         - 真實部門id
    * @param {number}    type                 - 種類(0:選修,1.必修)
    */
  addCourses: function({resource_id, actual_depid, type}) {
    return axios.post('/api/science/courses', {
      resource_id : resource_id,
      actual_depid: actual_depid,
      type: type,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * deleteCourses 刪除必選修
    * @param {number}    resource_id          - 資源id
    * @param {number}    actual_depid         - 真實部門id
  	*/   	
  deleteCourses: function(resource_id, actual_depid) {
    return axios.delete('/api/science/courses/', {
       data: 
        { resource_id: resource_id,
          actual_depid: actual_depid} }
    ).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * getFavorites 取得我的最愛列表
    * @param {number}    size                 - 筆數(預設值: 10)
    * @param {number}    offset               - 查詢筆數起點位移(預設值: 0)
    * @param {string}    by                   - 排序欄位(預設值: mtime, 允許值: "code", "title", "department", "category", "level", "rating", "mtime") 
    * @param {string}    order                - 排序方式(預設值: desc, 允許值: "desc", "asc") 
    */
  getFavorites: function({size, offset, keyword, by, order}) {
    return axios.get('/api/science/resources/favorites', {
      params: {
        size: size,
        offset: offset,
        keyword: keyword,
        by: by,
        order: order,
      }
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * addFavorite 新增我的最愛
    * @param {number}    resource_id          - 資源id
    */
  addFavorite: function(resource_id) {
    return axios.post('/api/science/favorites/', {
      resource_id : resource_id,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * deleteFavorite 刪除我的最愛
    * @param {number}    resource_id          - 資源id
  	*/   	
  deleteFavorite: function(resource_id) {
    return axios.delete('/api/science/favorites/', {
        data: 
        { resource_id: resource_id} }
    ).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /****************************************************************************************************
    *實體檔案相關
  /****************************************************************************************************  
  /**
    * deleteResourceFromJustup 刪除實體檔案
    * @param {string} fileId - fileId
    * @return none
  	*/   	
  deleteResourceFromJustup: function(fileId) {
    return axios.delete('/api/v2/file/' + fileId, {
      }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * addResourceToJustup 新增實體檔案
    * @param  {object[]}  file        - 上傳檔案的資料內容
    * @param  {string}    parentId    - 上傳檔案目的位置，當目的為檔案時，會自動建立檔案版本
    * @param  {string}    name        - 上傳檔案的檔名 (檔案取代允許不傳入檔名)
    * @param  {Number}    size        - size
    * @param  {Number}    chunkNumber - 分片編號，從 1 開始編號
    * @param  {Number}    chunkTotal  - 分片總數量
    * @param  {Number}    identifier  - 分片上傳合併序號，自行產生 UUID 進行至識別
    * @return {object}    result      - File
    */    
  addResourceToJustup: function(file, parentId, name, size, chunkNumber, chunkTotal, identifier) {
    var data = new FormData();
    data.append('name', name);
    data.append('file', file);
    data.append('size', size);
    data.append('chunkNumber', chunkNumber);
    data.append('chunkTotal', chunkTotal);
    data.append('identifier', identifier);
    
    var config = {
      header : {
       'Content-Type' : 'multipart/form-data'
      }
    };

    return axios.post('/api/v2/file/' + parentId, data, config, {
        parentId: parentId,
        name: name
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    }); 
  },
  /****************************************************************************************************  
    *分類相關
  /**************************************************************************************************** 
  /**
    * getCategoriesGroup 取得學院列表
    * @return {object[]}    result
    * @return {number}      result.id       - 學院id
    * @return {string}      result.name     - 學院名稱
    * @return {object[]}    result.category - 所包含的主題分類列表
  	*/   
    getCategoriesGroup: function() {
      return axios.get('/api/science/categoriesgroup').then(function(response) {
       return response.data;
     }).catch(function (error) {
       return error.response;
     });
   },
  /**
    * getCategories 取得主題分類列表
    * @return {object}    result
    * @return {number}    result.id    - 主題分類Id
    * @return {string}    result.code  - 主題分類代碼
    * @return {string}    result.title - 主題分類標題
  	*/   
  getCategories: function() {
   	return axios.get('/api/science/categories').then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  /**
    * fixCategory 修改主題分類
    * @param {number} id    - 主題分類Id
    * @param {string} title - 主題分類標題
    * @param {number} code  - 主題分類縮寫
    * @param {number} categoryGroupId - 隸屬學院Id
   	* @return none
  	*/   
  fixCategory: function(id, title, code = null, categoryGroupId = null) {
   	return axios.put('/api/science/categories/' + id, {
       title: title,
       code: code,
       categoryGroupId: categoryGroupId,
   	}).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  getCategoryOrder: function(type) {
    return axios.get('/api/science/categoriesorder/' + type).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  updateCategoryOrder: function(type, orderData) {
    return axios.post('/api/science/categoriesorder/' + type,
     orderData).then(function(response) {
     return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  restoreCategoryOrder: function(type) {
    return axios.delete('/api/science/categoriesorder/' + type).then(function(response) {
     return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * addCategory 新增主題分類
    * @param {string} code  - 主題分類代碼
   	* @param {string} title - 主題分類標題
   	* @return none
  	*/   
  addCategory: function(code, title, categoryGroupId = null) {
   	return axios.post('/api/science/categories', {
   		code: code,
      title: title,
      categoryGroupId: categoryGroupId,
   	}).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  /**
    * deleteCategory 刪除主題分類
    * @param {number} id - 主題分類Id
    * @return none
  	*/   
  deleteCategory: function(id) {
   	return axios.delete('/api/science/categories/' + id).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	}); 
  },
  /****************************************************************************************************  
    *白名單相關
  /****************************************************************************************************
  /**
    * getWhiteList 取得白名單清單
    * @return {object}    result
    * @return {number}    result.id    - email id
    * @return {string}    result.email - email address
  	*/   
  getWhiteList: function() {
   	return axios.get('/api/science/whitelist').then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  /**
    * fixWhiteList 修改白名單清單
    * @param {number} id    - email id
    * @param {string} email - email address
    * @return none
  	*/   
  fixWhiteList: function(id, email) {
   	return axios.put('/api/science/whitelist/' + id, {
   		email: email
   	}).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});   
  },
  /**
    * addWhiteList 新增白名單清單
    * @param {string} email - email address
   	* @return none
  	*/   
  addWhiteList: function(email) {
   	return axios.post('/api/science/whitelist', {
   		email: email
   	}).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  /**
    * deleteWhiteList 刪除白名單清單
    * @param {number} id - email id
    * @return none
  	*/   
  deleteWhiteList: function(id) {
   	return axios.delete('/api/science/whitelist/' + id).then(function(response) {
    	return response.data;
    }).catch(function (error) {
    	return error.response;
  	});
  },
  /****************************************************************************************************  
    *管理者相關
  /****************************************************************************************************
  /**
    * getAdminer 取得管理者清單
    * @return {object}    result
    * @return {string}    result.name - username
    */
  /*    
  getAdminer: function() {
    return axios.get('/api/science/adminers').then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  */
  /**
    * deleteAdminer 刪除管理者
    * @param {string} name - username
    * @return none
    */   
  deleteAdminer: function(name) {
    return axios.delete('/api/science/adminers/' + name).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
    * addAdminer 新增管理者
    * @param {string} name - username
    * @return none
    */   
  addAdminer: function(name) {
    return axios.post('/api/science/adminers', {
      name: name
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });  
  },
  /****************************************************************************************************  
    *user相關
  /****************************************************************************************************
  /**
    * getUser 取得使用者資訊
    * @return {object} user object
    */   
  getUser: function() {
    return axios.get('/api/v2/user').then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
    * 忘記密碼
    * @param  {string} email - email
    * @return {object} user object
    */  
  forgetPassword: function(email) {
    return axios.post('/account/api/users/forgetpwd', {
      email: email
    }).catch(function (error) {
      return error.response;
    }); 
  },
  /****************************************************************************************************  
    *下載相關
  /****************************************************************************************************
  /**
    * getVideoStream 取得影片串流播放網址
    * @param {number}  resourceId  - 資源Id
    * @param {string}  fileId      - 檔案fileId
    * @param {string}  type        - 返回型態，預設為下載網址: downloadurl (Allowed values: "downloadurl", "videopreview")
    * @return {object} videoPreviewURL
    * @return {string} videoPreviewURL.mp4 - 預覽網址
    * @return {string} videoPreviewURL.ogv - 預覽網址
    */   
  getVideoStream: function(resourceId, fileId, type) {
    return axios.get('/api/science/resources/download/' + resourceId + '/' + fileId + '/' + type, {
      params: {
        resourceId: resourceId,
        fileId: fileId,
        type: type
      }
    }).then(function(response) {
      return response;
    }).catch(function (error) {
      return error.response;
    });   
  },   
  /**
    * getPdf 取得 pdf 播放網址
    * @param {number}  resourceId  - 資源Id
    * @param {string}  fileId      - 檔案fileId
    * @return {object} URL
  	*/ 
  getPdf: function(resourceId, fileId) {
    return axios.get('/api/science/resources/download/' + resourceId + '/' + fileId + '/pdfpreview', {
      params: {
        resourceId: resourceId,
        fileId: fileId
      }
    }).then(function(response) {
      return response;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /****************************************************************************************************  
    *部門相關
  /****************************************************************************************************
  /**
    * getGroupList 取得部門清單
    * @return {object}    result
    * @return {string}    result.title  - department title
    * @return {string}    result.id     - department id
  	*/   
  getdDepartmentList: function() {
    return axios.get('/api/science/deps').then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
   /**
    * getActualDeps 取得真實部門列表
    */  
  getActualDeps: function() {
    return axios.get('/api/science/actualdeps').then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * addActualDep 新增真實部門
  	*/   
  addActualDep: function(name, depId, limit) {
    return axios.post('/api/science/actualdeps', {
      name: name,
      depId: depId,
      limit: limit,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * updateActualDep 修改真實部門
  	*/   
  updateActualDep: function(id, name, depid,  limit) {
    return axios.put('/api/science/actualdeps/' + id, {
      name: name,
      depid: depid,
      limit: limit,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * deleteActualDep 刪除真實部門
  	*/   
  deleteActualDep: function(id) {
    return axios.delete('/api/science/actualdeps/' + id
    ).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /****************************************************************************************************
    * 會員相關
  /****************************************************************************************************   
  /**
    * editPassword 編輯會員密碼（只能自己用）
    * @param {string} password - newpassword
    * @return {object} user object
    */   
  editPassword: function(password) {
    return axios.put('/api/science/members/password', {
      newpassword: password
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
    * getAccountList 取得會員帳號清單
    * @param  {number}    actual_depid   - 真實部門，過濾部門，預設不區分
    * @param  {number[]}  level   - 會員程度，預設不區分(Allowed values: 1-4)
    * @param  {number}    size    - 筆數，預設10
    * @param  {number}    offset  - 查詢筆數起點位移，預設0
    * @param  {string}    keyword - 關鍵字，for username, displayname
    * @param  {string}    by      - 排序欄位。(username:帳號,displayname:顯示名稱,dep:部門,level:權限,ismanager:身份,status:狀態) 預設值: username
    * @param  {string}    order   - 排序方式，預設值: desc
    * @return {object}    result
    * @return {string}    result.name      - member name
    * @return {object}    result.user      - member user info
    * @return {number}    result.user.username    - member username
    * @return {string}    result.user.displayname - member displayname
    * @return {number}    result.depId     - member dep ID
    * @return {number}    result.level     - member level
    * @return {boolean}   result.isManager - member is Manager
    * @return {object}    result.dep       - member department info
    * @return {number}    result.dep.id    - member department ID
    * @return {string}    result.dep.title - member department title
  	*/   
  getAccountList: function(actual_depid, level, size, offset, keyword, by, order) {
    return axios.get('/api/science/members',{ 
      params: {
        actual_depid: actual_depid,
        level: level,
        size: size,
        offset: offset,
        keyword: keyword,
        by: by,
        order: order,
      }
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * deleteAccount 刪除在科普的會員帳號
    * @param  {string}    name - 會員帳號
    * @return none
  	*/   
  deleteAccount: function(name) {
    return axios.delete('/api/science/members/clean/' + name, {
      name: name,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * addAccount 新增在科普的會員帳號
    * @param  {obj}       account             - 會員
    * @param  {string}    account.name        - 會員帳號
    * @param  {string}    account.displayName - 會員顯示名稱
    * @param  {string}    account.email       - 會員 Email
    * @param  {string}    account.password    - 會員 PWD
    * @param  {number}    account.depId       - 部門 Id
    * @param  {number}    account.actual_depid- 真實部門 Id
    * @param  {number}    account.level       - 會員等級
    * @param  {number}    account.isManager   - 1:部門管理員 0:一般會員
    * @param  {number}    account.status      - 1:開通 0:停權
    * @param  {number}    account.included    - 1:列入統計 0:不列入統計
    * @param  {number}    account.not_included_date    - 不列入統計時間
    * @return none
  	*/   
  addAccount: function(account) {
    return axios.post('/api/science/members', {
      name: account.name,
      displayname: account.displayName,
      email: account.email,
      password: account.password,
      depId: account.depId,
      actual_depid: account.actual_depid,
      level: account.level,
      isManager: account.isManager,
      status: account.status,
      included: account.included,
      not_included_date: account.not_included_date,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * editAccount 編輯在科普的會員帳號
    * @param  {obj}       account             - 會員
    * @param  {string}    account.name        - 會員帳號
    * @param  {string}    account.displayName - 會員顯示名稱
    * @param  {string}    account.email       - 會員 Email
    * @param  {string}    account.password    - 會員 PWD
    * @param  {number}    account.depId       - 部門 Id
    * @param  {number}    account.actual_depid- 真實部門 Id
    * @param  {number}    account.level       - 會員等級
    * @param  {number}    account.isManager   - 1:部門管理員 0:一般會員
    * @param  {number}    account.status      - 1:開通 0:停權
    * @param  {number}    account.included    - 1:列入統計 0:不列入統計
    * @param  {number}    account.not_included_date    - 不列入統計時間
    * @return none
  	*/   
  editAccount: function(account) {
    return axios.put('/api/science/members/' + account.name, {
      displayname: account.displayName,
      email: account.email,
      password: account.password,
      depId: account.depId,
      actual_depid: account.actual_depid,
      level: account.level,
      isManager: account.isManager,
      status: account.status,
      included: account.included,
      not_included_date: account.not_included_date,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * accountInfo 科普的會員帳號詳細資訊
    * @param  {string}    name  - 會員帳號
    * @return {string}    result.name  - member name
    * @return {number}    result.level  - member level
    * @return {boolean}   result.isManager  - member is Manager
    * @return {object}    result.dep  - member department obj
    * @return {number}    result.dep.id  - member department ID
    * @return {string}    result.dep.title  - member department title
  	*/   
  accountInfo: function(name) {
    return axios.get('/api/science/members/' + name, {
      name: name,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * accountCheck 檢查會員是否存在
    * @param  {string}    name  - 會員帳號
    * @return {boolean}   result - 0:不存在 1:存在
  	*/   
  accountCheck: function(name) {
    return axios.get('/api/science/members/check/' + name, {
      name: name,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });	
  },
  /**
    * accountSpinoff Spinoff會員資料
    * @param  {obj}       account             - 會員
    * @param  {string}    account.name        - 會員帳號
    * @param  {string}    account.new_name    - 新工號
    * @param  {string}    account.email       - 會員 Email
    * @param  {number}    account.actual_depid- 真實部門 Id
    * @param  {number}    account.level       - 會員等級
    * @return none
  	*/   
    accountSpinoff: function(account) {
      return axios.put('/api/science/members/spinoff/' + account.name, {
        new_name: account.new_name,
        email: account.email,
        actual_depid: account.actual_depid,
        level: account.level,
      }).then(function(response) {
        return response.data;
      }).catch(function (error) {
        return error.response;
      });
    },
  /**
  * popular 取得熱門作者
  * @return {number}    startTime          - 開始時間(timestamp)
  * @return {number}    endTime            - 結束時間(timestamp)
  */   
  getPopularAuthors: function(categoryId = [], startTime = null, endTime = null) {
    let url = '/api/science/members/popular';
    return axios.get(url, {
      params: {
        categoryId: categoryId,
        startTime: startTime,
        endTime: endTime
      }
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /****************************************************************************************************
    * 註冊相關
  /****************************************************************************************************  
  /**
    * registers 註冊帳號
    * @param  {string}    displayname         - 姓名，顯示名稱
    * @param  {string}    name                - 帳號，工號
    * @param  {string}    email               - 信箱
    * @param  {number}    actual_depid        - 部門 Id
    * @param  {number}    level               - 會員等級
    * @param  {string}    password            - 密碼
    * @return none
  	*/   
  register: function(displayname, name, email, actual_depid, level, password) {
    return axios.post('/api/science/registers/', {
      displayname: displayname,
      name: name,
      email: email,
      actual_depid: actual_depid,
      level: level,
      password: password,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * getRegisterList 獲得註冊列表
    * @param  {number}      actual_depid   - 部id
    * @return {object[]}    result
  	*/   
  getRegisterList: function(actual_depid = null) {
    let dep = '';
    if(actual_depid) {
      dep = actual_depid.toString();
    }
    return axios.get('/api/science/registers/' + dep
    ).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
    },
  /**
    * registerApproval 更新帳號狀態
    * @param  {string}    name        - 會員帳號
    * @param  {string}    email       - 會員 Email
    * @param  {number}    status      - 1:開通 0:不開通
    * @return none
  	*/   
  registerApproval: function(name, status, email) {
    return axios.put('/api/science/registers/', {
      name: name,
      status: status,
      email: email,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /****************************************************************************************************
    * 評價相關
  /****************************************************************************************************  
  /**
    * 新增主題的評價
    * @param {number}  resourceId  - 評論的主題Id
    * @param {number}  rating      - Allowed values: 1-5
    * @param {string}  comment     - 評論
    * @param {bool}    anonymous   - 是否匿名
    * @return none
  	*/   
  addComment: function(resourceId, rating, comment, anonymous) {
    return axios.post('/api/science/reviews/' + resourceId, {
      resourceId: resourceId,
      rating: rating,
      comment: comment,
      anonymous: anonymous
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },  
  /**
    * 刪除主題的評價
    * @param  {number} reviewId - 評論Id
    * @return none
  	*/   
  deleteComment: function(reviewId) {
    return axios.delete('/api/science/reviews/' + reviewId, {
      reviewId: reviewId,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  }, 
  /**
    * 修改主題的評價
    * @param {number}  reviewId    - 評論Id
    * @param {number}  rating      - Allowed values: 1-5
    * @param {string}  comment     - 評論
    * @param {bool}    anonymous   - 是否匿名
    * @return none
  	*/   
  changeComment: function(reviewId, rating, comment, anonymous) {
    return axios.put('/api/science/reviews/' + reviewId, {
      reviewId: reviewId,
      rating: rating,
      comment: comment,
      anonymous: anonymous
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  }, 
  /**
    * 刪除主題的回覆
    * @param  {number} reviewId - 評論Id
    * @return none
  	*/   
  deleteReply: function(reviewId) {
    return axios.delete('/api/science/reviews/reply/' + reviewId, {
      reviewId: reviewId,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },
  /**
    * 回覆主題的評價
    * @param {number}  reviewId  - 評論的主題Id
    * @param {string}  content   - 評論
    * @return none
  	*/   
  replyComment: function(reviewId, content) {
    return axios.put('/api/science/reviews/reply/' + reviewId, {
      reviewId: reviewId,
      content: content
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  }, 
  /*
  refreshToken: function(callback) {
    return axios.get('/api/v1.1/auth/', {
      method: 'dorefreshtoken',
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  } 
  */
 /****************************************************************************************************
    * 統計相關
  /****************************************************************************************************  
  /**
  * statistics 取得統計資料
  * @param {number}    startTime          - 開始時間(timestamp)
  * @param {number}    endTime            - 結束時間(timestamp)
  */   
  getStatistics: function({startTime = null, endTime = null}) {
    let url = '/api/science/statistics';
    return axios.get(url, {
      params: {
        startTime: startTime,
        endTime: endTime
      }
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
  * statistics/views 取得閱覽記錄
  * @param {number}    actual_depid       - 真實部門id
  * @param {number}    startTime          - 開始時間(timestamp)
  * @param {number}    endTime            - 結束時間(timestamp)
  */   
  getStatisticsViews: function({actual_depid = null, startTime = null, endTime = null}) {
    let url = '/api/science/statistics/views';
    return axios.get(url, {
      params: {
        actual_depid: actual_depid,
        startTime: startTime,
        endTime: endTime
      }
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },
  /**
  * statistics/watch 取得會員閱覽記錄
  * @param {number}    startTime          - 開始時間(timestamp)
  * @param {number}    endTime            - 結束時間(timestamp)
  */   
  getStatisticsWatch: function({id, startTime = null, endTime = null}) {
    let url = '/api/science/statistics/watch/' + id;
    return axios.get(url, {
      params: {
        startTime: startTime,
        endTime: endTime
      }
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });   
  },

  /**
  * statistics/watch 批次取得會員閱覽記錄
  * @param {number}    startTime          - 開始時間(timestamp)
  * @param {number}    endTime            - 結束時間(timestamp)
  * @param {String[]}  names              - 會員名称
  * @param {String}    resource_title     - 主題名稱
  */   
  getStatisticsWatchAdvanced: function({startTime = null, endTime = null, names = [], resource_title = null}) {
    return axios.post('/api/science/statistics/watch', {
      startTime: startTime,
      endTime: endTime,
      names: names,
      resource_title: resource_title,
    }).then(function(response) {
      return response.data;
    }).catch(function (error) {
      return error.response;
    });
  },

  /**
    * getExternalLinks 取得友站連結
    * @return {object}    result
    * @return {number}    result.id           - 外部連結Id
    * @return {string}    result.title        - 外部連結標題
    * @return {string}    result.link         - 外部連結URL
    * @return {number}    result.actual_depid - 真實部門Id
  	*/   
    getExternalLinks: function() {
      return axios.get('/api/science/externallinks').then(function(response) {
       return response.data;
     }).catch(function (error) {
       return error.response;
     });
   },
};



// WEBPACK FOOTER //
// ./src/api/api.js